function createAttachment(sess, id, title, url, fileType, status, postId, image) {
    const { ForumAttachment, Post } = sess;
    let targetPost = null;

    if (postId) {
        if (!Post.exists({id: postId})) {
            throw new Error(`there is not any forum post with this id '${postId}'`);
        }
        targetPost = Post.withId(postId);
    }
    const forumAttachmentModel = ForumAttachment.create({
        id: id,
        title: title,
        url: url,
        uploadingProgress: 0,
        fileType: fileType,
        post: targetPost,
        status: status || 'uploaded',
        image
    });
    
    return forumAttachmentModel
}

function changeAttachmentStatus(sess, id, status) {
    const { ForumAttachment } = sess;
    if (!ForumAttachment.exists({id})) {
        throw new Error(`there is not any forum attachment with this id '${id}'`);
    }

    return ForumAttachment.withId(id).update({
        status
    });
}

function changeAttachmentProgress(sess, id, progress) {
    const { ForumAttachment } = sess;
    if (!ForumAttachment.exists({id})) {
        throw new Error(`there is not any forum attachment with this id '${id}'`);
    }

    return ForumAttachment.withId(id).update({
        progress
    });
}

function attachAttachmentToPost(sess, id, postId) {
    const { ForumAttachment, Post } = sess;

    if (!Post.exists({id: postId})) {
        throw new Error(`there is not any forum post with this id '${postId}'`);
    }
    const targetPost = Post.withId(id);
    return ForumAttachment.withId(id).update({
        post: targetPost,
    });
}

function deleteAttachment(sess, id) {
    const { ForumAttachment } = sess;
    if (!ForumAttachment.exists({id})) {
        throw new Error(`there is not any forum attachment with this id '${id}'`);
    }

    ForumAttachment.withId(id).delete();
}

function setAttachmentCorrectValue(sess, id, newId, url, title, image) {
    const { ForumAttachment } = sess;
    if (!ForumAttachment.exists({id})) {
        throw new Error(`there is not any forum attachment with this id '${id}'`);
    }

    const oldAttachmentModel = ForumAttachment.withId(id);
    ForumAttachment.create({
        id: newId,
        title: oldAttachmentModel.title,
        url: url,
        uploadingProgress: oldAttachmentModel.uploadingProgress,
        fileType: oldAttachmentModel.fileType,
        post: oldAttachmentModel.post,
        status: 'uploaded',
        image
    });
    oldAttachmentModel.delete();
}

function deleteAllDraftAttachment(sess) {
    const { ForumAttachment } = sess;
    ForumAttachment.all().filter({
        post: null,
    }).delete();
}

function deleteAllPostAttachment(sess, postId) {
    const { Post } = sess;

    if (!Post.exists({id: postId})) {
        throw new Error(`there is not any forum post with this id '${postId}'`);
    }
    Post.withId(postId).attachments.all().delete();
}

export default {
    createAttachment,
    changeAttachmentStatus,
    changeAttachmentProgress,
    attachAttachmentToPost,
    deleteAttachment,
    setAttachmentCorrectValue,
    deleteAllDraftAttachment,
    deleteAllPostAttachment,
}